<template>
	<section class="section-box">
		<div class="container-curriculos">
			<div class="left-side">
				<div class="person">
					<span class="img">
						<feather type="user" size="50" />
					</span>
					<span class="name">{{ `${dados[0].nome ? dados[0].nome : 'Sem nome'}` }}</span>
					<span class="resume">{{
						(dados[0].nacionalidade ? dados[0].nacionalidade : '~') +
						', ' +
						(dados[0].idade ? dados[0].idade : '~') +
						' anos, ' +
						(dados[0].estado_civil ? dados[0].estado_civil : '~')
					}}</span>
					<div>
						<div class="social_media">
							<a
								v-if="dados[0].instagram"
								:title="formatInsta(dados[0].instagram)"
								target="_blank"
								:href="`https://www.instagram.com/${formatInsta(dados[0].instagram)}`"
								class="instagram"
							>
								<feather class="socialIcon insta" type="instagram" size="25px" />
							</a>
							<a
								v-if="dados[0].linkedin"
								class="linkedin"
								:title="formatLn(dados[0].linkedin)"
								target="_blank"
								:href="`https://www.linkedin.com/in/${formatLn(dados[0].linkedin)}`"
							>
								<feather class="socialIcon ln" type="linkedin" size="25px" />
							</a>
						</div>
						<Button
							height="34px"
							width="150px"
							font-weight="400"
							font-size="0.8125rem"
							border-radius="3px"
							title="Download"
							:icon="{ color: '#00c9a7', size: '18px', type: 'arrow-down-circle' }"
							@click="exportPdf(dados[0].id)"
						/>
					</div>
				</div>
				<div class="interesse">
					<div class="box-objetivos">
						<span class="title">Área de Interesse</span>
						<div class="tag-box">
							<Tag
								v-for="interesse of area"
								:key="interesse.id"
								:title="interesse.area"
								border-radius="3px"
								margin-bottom="7px"
							/>
						</div>
					</div>
					<div class="box-objetivos">
						<span class="title">Objetivo Profissional</span>
						<div class="tag-box">
							<span>{{ dados[0].objetivo }}</span>
						</div>
					</div>
					<div class="box-objetivos">
						<span class="title">Pretensão Salarial</span>
						<div class="tag-box">
							<Tag
								:title="transformToBrl(dados[0].pretensao)"
								border-radius="3px"
								width="50%"
								margin-bottom="7px"
							/>
						</div>
					</div>
					<div class="box-objetivos">
						<span class="title">Idiomas</span>
						<div class="idiomas-box">
							<span>Inglês:</span>
							<Tag :title="dados[0].ingles" border-radius="3px" />
						</div>
						<div class="idiomas-box">
							<span>Espanhol:</span>
							<Tag :title="dados[0].espanhol" border-radius="3px" />
						</div>
					</div>
				</div>
			</div>
			<div class="right-side">
				<div class="pessoal">
					<div class="title">Dados Pessoais</div>
					<div class="data-pessoal">
						<div class="box-data">
							<span class="label-data">Nome Completo:&nbsp;</span><span class="data-info">{{ `${dados[0].nome ? dados[0].nome : '~'}` }}</span>
						</div>
						<div class="box-data">
							<span class="label-data">CPF:&nbsp;</span><span class="data-info">{{
								`${dados[0].cpf ? formatCnpjCpf(dados[0].cpf) : '~'}`
							}}</span>
						</div>
						<div class="box-data">
							<span class="label-data">Email:&nbsp;</span><span class="data-info"> {{ `${dados[0].email ? dados[0].email : '~'}` }}</span>
						</div>
						<div class="box-data">
							<span class="label-data">Idade:&nbsp;</span><span class="data-info"> {{ `${dados[0].idade ? dados[0].idade : '~'}` }}</span>
						</div>
						<div class="box-data">
							<span class="label-data">Gênero:&nbsp;</span><span class="data-info"> {{ `${dados[0].genero ? dados[0].genero : '~'}` }}</span>
						</div>
						<div class="box-data">
							<span class="label-data">Possui Filhos:&nbsp;</span><span class="data-info">
								{{ `${dados[0].possui_filho !== 1 ? 'Não' : 'Sim'}` }}</span>
						</div>
						<div class="box-data">
							<span class="label-data">Possui Deficiencia:&nbsp;</span><span class="data-info">
								{{ `${dados[0].possui_deficiencia !== 1 ? 'Não' : 'Sim'}` }}</span>
						</div>
						<div class="box-data">
							<span class="label-data">Telefone:&nbsp;</span><span class="data-info">
								{{
									`${dados[0].possui_filho ? formataNumeroTelefone(dados[0].telefone) : '~'}`
								}}</span>
						</div>
						<div class="box-data">
							<span class="label-data">Celular:&nbsp;</span><span class="data-info">
								{{ dados[0].celular ? formataNumeroTelefone(dados[0].celular) : '~' }}</span>
						</div>
						<div class="box-data">
							<span class="label-data">Endereço:&nbsp;</span><span class="data-info">
								{{
									parseAddres({
										rua: dados[0].endereco || null,
										numero: dados[0].numero || null,
										cidade: dados[0].cidade || null,
										estado: dados[0].estado || null,
										cep: dados[0].cep || null,
									})
								}}</span>
						</div>
					</div>
				</div>
				<div v-if="formacao.length > 0" class="formacao-container">
					<div class="title">Formação Acadêmica</div>
					<div class="formacao-box">
						<div
							v-for="graduacao of formacao"
							:key="graduacao.id"
							class="formacao"
							:class="graduacao.situacao_formacao === 'Concluído' ? 'concluido' : 'cursando'"
						>
							<div>
								<feather type="award" class="formacao-icon" />
							</div>
							<div class="formacao-header">
								{{ graduacao.formacao }}
							</div>
							<div class="formacao-title">
								{{ graduacao.curso_formacao }}
							</div>
							<div>
								<Status
									:state="graduacao.situacao_formacao === 'Concluído' ? 1 : 0"
									:data="
										graduacao.situacao_formacao === '0'
											? 'Não Informado'
											: graduacao.situacao_formacao
									"
								/>
							</div>
						</div>
						<div
							v-for="graduacao of formacao"
							v-show="graduacao.especializacao !== '0'"
							:key="graduacao.especializacao"
							class="formacao"
							:class="graduacao.situacao_especializacao === 'Concluído' ? 'concluido' : 'cursando'"
						>
							<div>
								<feather type="award" class="formacao-icon" />
							</div>
							<div class="formacao-header">
								{{ graduacao.especializacao === '0' ? 'Não Informado' : graduacao.especializacao }}
							</div>
							<div class="formacao-title">
								{{ graduacao.curso_especializacao || 'Não Informado' }}
							</div>
							<div>
								<Status
									:state="graduacao.situacao_especializacao === 'Concluído' ? 1 : 0"
									:data="
										graduacao.situacao_especializacao === '0'
											? 'Não Informado'
											: graduacao.situacao_especializacao
									"
								/>
							</div>
						</div>
					</div>
					<div v-if="dados[0].outros_cursos">
						<div class="title">Outros Cursos</div>
						<div class="outros-cursos">
							<p>{{ dados[0].outros_cursos }}</p>
						</div>
					</div>
				</div>
				<div class="third-box-row">
					<div class="title-profissional">
						<span>Profissional</span>
					</div>
					<div class="resume-profissional">
						<p>{{ dados[0].resumo }}</p>
						<h1><span> Último Salario: </span>{{ transformToBrl(dados[0].ultimo_salario) }}</h1>
					</div>
				</div>
			</div>
		</div>
		<div v-if="exp.length > 0" class="experiencia">
			<Timeline title="Experiência" :data="exp">
				<div slot="subtitle" slot-scope="row" class="subtitle">
					{{ row.row.cargo }}
				</div>

				<div slot="details" slot-scope="row">
					<div class="label-exp">
						<span>Período:</span>
						<span class="exp-periodo">{{
							solveDateInterval(row.row.dt_inicio, row.row.dt_fim)
						}}</span>
					</div>
					<div class="label-exp">
						<span>Segmento:</span>
						<span class="exp-periodo">{{ row.row.segmento }}</span>
					</div>
					<div class="label-exp">
						<span>Descrição:</span>
						<span class="exp-periodo">{{ row.row.descricao }}</span>
					</div>
				</div>
			</Timeline>
			<!--    <div v-for="row of exp" :key="row.id" class="box-exp">
        <div class="label-exp">
          <span>Empresa:</span>
          <span class="exp-periodo"> {{ row.empresa ? row.empresa : '~' }}</span>
        </div>

        <div class="label-exp">
          <span>Periodo:</span>
          <span class="exp-periodo">{{ solveDateInterval(row.dt_inicio, row.dt_fim) }}</span>
        </div>
        <div class="label-exp">
          <span>Segmento:</span>
          <span class="exp-periodo">{{ row.segmento ? row.segmento : '~' }}</span>
        </div>
        <div class="label-exp">
          <span>Cargo:</span>
          <span class="exp-periodo">{{ row.cargo ? row.cargo : '~' }}</span>
        </div>
        <div class="label-exp descricao">
          <span>Descrição:</span>
          <p>
            {{ row.descricao ? row.descricao : '~' }}
          </p>
        </div>
      </div> -->
		</div>
	</section>
</template>

<script>
import * as ecAxios from '../../util/ecAxios';
import global from '../../mixins/global';
import Button from '../../layout/components/buttons/Default';
import Tag from '../../layout/components/tags/k-tag-simple';
import Status from '../../layout/components/tags/cursoStatus';
import PdfExport from '../../services/pdf-export';
import Timeline from '../../layout/components/timeline';

require('jspdf-autotable');

export default {
	components: {
		Button,
		Tag,
		Status,
		Timeline,
	},
	mixins: [global],

	data() {
		return {
			dados: [
				{
					id: 1492,
					email: '',
					nome: '',
					idade: 0,
					genero: '',
					estado_civil: '',
					nacionalidade: '',
					cpf: '',
					status: '',
					possui_filho: 0,
					possui_deficiencia: 0,
					cep: '00000000',
					estado: '',
					cidade: '',
					bairro: '',
					endereco: '',
					telefone: '',
					celular: '',
					instagram: '',
					linkedin: '',
					outros_cursos: null,
					ingles: 'Nenhum',
					espanhol: 'Nenhum',
					objetivo: '',
					pretensao: '',
					resumo: '',
					ultimo_salario: null,
					numero: 28,
				},
			],
			icons: [
				{
					type: 'settings',
					color: '#7159C1',
					backgroundColor: '#7159C131',
				},
				{ type: 'sun', color: '#ffba08', backgroundColor: '#ffba0831' },

				{ type: 'users', color: '#3a86ff', backgroundColor: '#3a86ff31' },

				{ type: 'sliders', color: '#c9184a', backgroundColor: '#c9184a31' },
				{ type: 'trending-up', color: '#208b3a', backgroundColor: '#208b3a31' },
			],
			area: [],
			data: [],
			exp: [],
			formacao: [],
			empPagCollumn: [
				{
					field: 'id',
					label: 'ID',
					width: '40',
					numeric: true,
				},
				{
					field: 'nomerazao',
					label: 'Razão Social',
				},
				{
					field: 'pessoa_id',
					label: 'Pessoa Id',
				},
				{
					field: 'rgie',
					label: 'RGIE',
					centered: true,
				},
				{
					field: 'status',
					label: 'Status',
				},
				{
					field: 'tipopessoa',
					label: 'Tipo Pessoa',
				},
			],
			pagamentoCollumn: [
				{
					field: 'id',
					label: 'ID',
					width: '40',
					numeric: true,
				},
				{
					field: 'descricao',
					label: 'Descrição',
				},
				{
					field: 'integracao_id',
					label: 'Integração Id',
				},
				{
					field: 'validdaysavg',
					label: 'validdaysavg',
					centered: true,
				},
				{
					field: 'status',
					label: 'Status',
				},
				{
					field: 'associado_id',
					label: 'Associado ID',
				},
			],
		};
	},
	created() {
		this.getDataDetails();
	},
	methods: {
		parseAddres(data) {
			let dados = data;
			if (!dados.rua) {
				dados.rua = 'Não informado';
			}
			if (!dados.numero) {
				dados.numero = 'S/N';
			}
			if (!dados.cidade) {
				dados.cidade = 'não informado';
			}
			if (!dados.estado) {
				dados.estado = 'não informado';
			}
			if (!dados.cep) {
				dados.cep = '00000-000';
			}
			dados = `${dados.rua}, ${dados.numero}, ${dados.cidade}, ${dados.estado} - ${dados.cep}`;
			return dados;
		},
		parseContato(telefone, celular) {
			let contato = '';
			if (telefone) {
				contato = telefone;
			}
			if (celular) {
				contato = `${contato || 'Sem contato'} | ${celular}`;
			}
			return contato;
		},
		async exportPdf(id) {
			let data = null;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_CURRICULOS}/show`, {
					id,
				})
				.then((response) => {
					data = response.data.curriculo;
				})
				.catch((e) => {
					// eslint-disable-next-line no-console
					console.error(e);
				});
			// eslint-disable-next-line
			let { dados, exp, formacao, area } = data;
			// eslint-disable-next-line prefer-destructuring
			dados = dados[0];

			exp.forEach((experiencia) => {
				// eslint-disable-next-line no-param-reassign
				experiencia.intervalo = this.solveDateInterval(experiencia.dt_inicio, experiencia.dt_fim);
			});
			const localidade = {
				rua: dados.endereco || null,
				numero: dados.numero || null,
				cidade: dados.cidade || null,
				estado: dados.estado || null,
				cep: dados.cep || null,
			};
			dados.subtitlename = `${dados.nacionalidade}, ${dados.idade} anos, ${dados.estado_civil}`;
			dados.contato = this.parseContato(dados.telefone, dados.celular);
			dados.endereco = this.parseAddres(localidade);
			dados.pretensao = this.transformToBrl(dados.pretensao);
			dados.ultimo_salario = this.transformToBrl(dados.ultimo_salario);
			const pdf = new PdfExport({
				dados,
				exp,
				formacao,
				area,
			});
			pdf.exportCurriculo();
		},
		formatInsta(username) {
			return username.trim().replace('@', '').replace(/\s/g, '');
		},
		formatLn(username) {
			return username.replace('https://www.linkedin.com/in/', '').replace(/\s/g, '');
		},
		solveDateInterval(dtInital, dtFinal) {
			let solveInital = 'Não Informado';
			let solveFinal = 'Não Informado';
			if (dtFinal === 'A') {
				solveFinal = 'Atualmente';
			}
			if (dtFinal && dtFinal !== 'A') {
				solveFinal = this.dateToBrasil(dtFinal);
			}

			if (dtInital) {
				solveInital = this.dateToBrasil(dtInital);
			}

			const str = `${solveInital} até ${solveFinal}`;

			return str;
		},
		getIconType() {},
		async getDataDetails() {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.CURRICULOS}/show`, {
					id: this.$route.params.id,
				})
				.then((response) => {
					this.dados = response.data.curriculo.dados;
					this.area = response.data.curriculo.area;
					const newExp = [];
					response.data.curriculo.exp.forEach((exp) => {
						newExp.push({
							...exp,
							icon: this.icons[this.getRandomInt(0, this.icons.length)],
						});
						return newExp;
					});
					this.exp = newExp;
					this.formacao = response.data.curriculo.formacao;

					const data = this.area.map((item) => item.area);
					this.data.push(data.join(', '));
				})
				.catch((e) => {
					// eslint-disable-next-line no-console
					console.error(e);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.insta {
	color: #fff;
}
.ln {
	color: #fff;
}
.linkedin {
	background-color: #0a66c2;
	border-radius: 20%;
}
.instagram {
	border-radius: 20%;
	background: radial-gradient(
		circle at 33% 100%,
		#fed373 4%,
		#f15245 30%,
		#d92e7f 62%,
		#9b36b7 85%,
		#515ecf
	);
}
.linkedin,
.instagram {
	margin-left: 7px;
	margin-right: 7px;
	padding: 7px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.social_media {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 20px;
}
.subtitle {
	font-size: 10px;
	margin-top: 4px;
}
.box-exp {
	font-size: 12px;
	background-color: #ffffff;
	margin-top: 10px;
	display: flex;
	border-radius: 3px;
	align-items: flex-start;
	padding: 10px;
	color: #979797 !important;
	font-weight: bold;
	flex-direction: row;
	width: 100%;
	justify-content: space-between;
}
.title-descricao {
	text-align: center;
	width: 25%;
}
.label-exp span {
	color: #000;
	font-weight: bold;
	margin-bottom: 5px;
}
.descricao {
	display: flex;
	flex-direction: column;
	width: 30% !important;
}
.label-exp {
	display: flex;
	margin-top: 10px;

	flex-direction: column;
	font-weight: 500;
	justify-content: flex-start;
	margin-bottom: 10px;
}
.label-exp:last-child {
	margin-right: 0px;
}
.experiencia {
	margin-bottom: 30px;
	margin-top: 30px;
}
.exp-periodo {
	display: flex;
	font-weight: 500 !important;
	white-space: nowrap;
	color: #979797 !important;
}
.left-side,
.right-side {
	display: flex;
	flex-direction: column;
}
.left-side {
	width: 25%;
	padding: 30px;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
	background-color: #fff;
}
.right-side {
	width: 75%;
}
.resume-profissional {
	margin-top: 20px;
	display: flex;
	font-size: 12px;
	flex-direction: column;
}
.resume-profissional h1 {
	margin-top: 20px;
}
.resume-profissional h1 span {
	font-weight: bold;
}
.title-profissional {
	font-weight: bold;
}
.idiomas-box {
	display: flex;
	margin-top: 10px;
	font-size: 12px;
	align-items: center;
}
.idiomas-box span {
	margin-right: 5px;
}
.third-box-row {
	display: flex;
	padding: 30px;
	margin-left: 30px;
	flex-direction: column;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
	max-height: 400px;
	background-color: #fff;
	margin-top: 30px;
}
.formacao-header {
	font-weight: bold;
}
.formacao-title {
	text-align: center;
	margin: 10px;
}
.formacao-icon {
	width: 40px;
	margin-bottom: 20px;
}
.outros-cursos {
	font-size: 12px;
	margin-top: 10px;
}
.concluido .formacao-icon {
	color: #28c76f;
}
.cursando .formacao-icon {
	color: #ff9f43;
}
.formacao-container .title {
	all: unset;
	font-weight: bold;
	font-size: 14px;
}
.formacao {
	margin-bottom: 30px;
	padding: 15px;
	font-size: 12px;
	width: 23%;
	margin-right: 2%;
	justify-content: center;
	align-items: center;
	justify-content: center;
	display: flex;
	flex-direction: column;
	color: #000;
	border-radius: 4px;
}
.concluido {
	border: 2px solid #28c76f !important;
}
.cursando {
	border: 2px solid #ff9f43 !important;
}
.formacao-box {
	margin-top: 25px;
	margin-right: auto;
	width: 100%;
	display: flex;
	flex-wrap: wrap;
}
.formacao-container {
	display: flex;
	flex-direction: column;
	padding: 30px;
	margin-top: 30px;
	margin-left: 30px;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
	//max-height: 400px;
	background-color: #fff;
}
.second-box-row {
	display: flex;
	justify-content: space-between;
}
.tag-box {
	display: flex;
	width: 100%;
	padding-top: 15px;
	margin-bottom: 30px;
	justify-content: space-between;
	flex-wrap: wrap;
}
.tag-box span {
	font-size: 12px;
}
.box-objetivos {
	display: flex;
	flex-direction: column;
	width: 100%;
}
.interesse .title {
	font-size: 14px;
	font-weight: bold;
	margin-bottom: 5px;
}
.interesse {
	display: flex;
	width: 100%;
	flex-direction: column;
	border-radius: 3px;
}
.pessoal-box {
	width: 75%;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.irineu {
	display: flex;
}
.data-pessoal {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
}
.box-data {
	display: flex;
	padding-top: 15px;
	padding-right: 15px;
	padding-bottom: 15px;
	font-size: 12px;
}
.label-data {
	font-weight: bold;
	color: rgb(90, 90, 90);
	margin-right: 4px;
}
.pessoal .title {
	font-size: 14px;
	font-weight: bold;
}
.container-curriculos {
	width: 100%;
	display: flex;
	margin-bottom: 30px;
	flex-direction: row;
}
.pessoal {
	margin-left: 30px;
	padding: 30px;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
	max-height: 400px;
	background-color: #fff;
}

.person {
	width: 100%;
	height: 330px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.person .img {
	background-color: rgb(206, 206, 206);
	border-radius: 50%;
	width: 100px;
	height: 100px;
	align-items: center;
	justify-content: center;
	display: flex;
}
.person .name {
	font-size: 14px;
	margin-top: 30px;
	margin-bottom: 5px;
	font-weight: bold;
	text-align: center;
}
.person .resume {
	margin-bottom: 25px;
}
.data-inf {
	color: #979797 !important;
}
</style>

